export default {
    webRTC: "webRTC",
    video: "video",
    image: "image",
    mediaQuery: "mediaQuery",
    SVG: "SVG",
    localMediaStream: "localMediaStream",
}